export default __webpack_public_path__ + "static/media/zine-cover8.ade144fc.png";